module.exports = __webpack_public_path__ + "static/media/sg13tj93.16b31123.png";